import { getRem, typographyBody1 } from 'lib/core';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { TOAST_VARIANTS } from '../constants';

const ToastBody = ({ variant, withMultipleActions, ...other }) => (
  <StyledToastBody $variant={variant} $withMultipleActions={withMultipleActions} {...other} />
);

const StyledToastBody = styled.div`
  ${({ theme }) => typographyBody1(theme)};
  background-color: ${({ theme }) => theme.color.additional.light.value};
  border-bottom-right-radius: ${({ theme }) => theme.size.borderRadius.large.value};
  border-color: ${({ $variant = TOAST_VARIANTS.NEUTRAL, theme }) => theme.color.system[$variant][500].value};
  border-style: solid;
  border-top-right-radius: ${({ theme }) => theme.size.borderRadius.large.value};
  border-width: ${getRem('2px')} ${getRem('2px')} ${getRem('2px')} 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: ${({ $withMultipleActions = false }) => ($withMultipleActions ? 'column' : 'row')};
  min-width: 0;
  width: 100%;
`;

ToastBody.propTypes = {
  /** Any content inserted between component tags */
  children: PropTypes.node.isRequired,
  /** Changes style depending on variant. */
  variant: PropTypes.oneOf(Object.values(TOAST_VARIANTS)),
  /** If true, changes body structure to column */
  withMultipleActions: PropTypes.bool,
};

export { ToastBody };
